import React, { useState } from 'react';
import debounce from 'lodash/debounce';
import styled from 'styled-components';
import { FieldWrapper, Input, Text } from 'components';
import { theme, toRem } from 'design';

interface InputCharCounterProps {
  label: string;
  countMax: number;
  maxLength?: number;
  optional?: boolean;
  onInputChange?: (inputValues: { value: string; error: boolean }) => void;
}

interface InputCharCounterStyleProps {
  charCount: number;
  countMax: number;
}

const Layout = styled.div<InputCharCounterStyleProps>`
  width: 100%;

  .character-counter {
    color: ${({ charCount, countMax }) => (charCount > countMax ? theme.color.danger[50] : theme.color.neutral[700])};
    padding-top: ${toRem(theme.space.sm)};
  }
`;

const InputCharCounter: React.FC<InputCharCounterProps> = ({ label, countMax, maxLength, optional, onInputChange }) => {
  const [charCount, setCharCount] = useState(0);

  const handleChange = (newVal: string) => {
    setCharCount(newVal.length);
    if (onInputChange) onInputChange({ value: newVal, error: newVal.length > countMax });
  };

  const debounceInputChange = debounce(handleChange, 300);

  return (
    <Layout charCount={charCount} countMax={countMax} data-cy="input-char-counter">
      <FieldWrapper label={label} optional={optional}>
        <Input maxLength={maxLength} onChange={(e) => debounceInputChange(e.currentTarget.value)} />
        <Text size="xxsmall" className="character-counter">
          {charCount}/{countMax}
        </Text>
      </FieldWrapper>
    </Layout>
  );
};

export default InputCharCounter;
